import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import LiveBody from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Body") {
    return [LiveBody];
  }
};
